module.exports = __webpack_public_path__ + "static/media/choose-battle-on-ground-challenge.37878dc7.png";